module.exports = __webpack_public_path__ + "quality.1fkW-hOH.svg";